import { Fragment } from "react";
import { PlusCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { hasPermission, type User, type RoleDefinition } from "@/lib/auth";
import { CREATE_WORKSPACES_PERMISSION } from "@shared/people-access";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

/** Used by the shared desktop/phone sidebar, with server-projected exceptions. */
export function CreateWorkspaceMenuItem({ user, roles, onCreate }: {
  user: User;
  roles: RoleDefinition[];
  onCreate: () => void;
}) {
  const { t } = useTranslation();
  if (!hasPermission(user, CREATE_WORKSPACES_PERMISSION, roles)) return null;
  return <Fragment>
    <DropdownMenuSeparator />
    <DropdownMenuItem
      onClick={onCreate}
      className="focus:bg-sidebar-accent focus:text-sidebar-accent-foreground cursor-pointer"
      data-testid="button-create-workspace"
    >
      <PlusCircle className="me-2 h-3 w-3" />
      {t("workspace.createWorkspace")}
    </DropdownMenuItem>
  </Fragment>;
}
